module.exports = __webpack_public_path__ + "img/new5.b5b79f56.png";